(() => {
  'use strict';

  const message = {
    consent: 'メール配信への同意にチェックを入れてください。',
    email: '正しいメールアドレスを入力してください。',
    pending: '登録中…',
    accepted: '登録を受け付けました。確認メールが届いた場合は、メール内のリンクから登録を完了してください。',
    failed: '登録できませんでした。時間をおいて再度お試しください。',
    unavailable: '現在メール登録を受け付けられません。時間をおいて再度お試しください。',
    rateLimit: '送信が混み合っています。少し時間をおいて再度お試しください。',
  };

  const feedback = (form, text, error = false) => {
    const status = form.querySelector('[data-mm-newsletter-status]');
    status.hidden = false;
    status.textContent = text;
    status.setAttribute('role', error ? 'alert' : 'status');
    status.classList.toggle('is-error', error);
    return status;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const signup = form.closest('[data-mm-newsletter]');
    if (!signup) return;

    const email = form.querySelector('[data-mm-newsletter-email]');
    const consent = form.querySelector('[data-mm-newsletter-consent]');
    if (!email || !consent) return;
    email.value = email.value.trim();

    if (!email.validity.valid || !consent.checked) {
      event.preventDefault();
      feedback(form, email.validity.valid ? message.consent : message.email, true);
      form.reportValidity();
      return;
    }

    // The native customer form remains the explicit Shopify route. Never
    // silently send a failed Klaviyo registration to a different destination.
    const provider = signup.dataset.provider || 'shopify';
    if (provider === 'shopify') return;
    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    const key = (signup.dataset.key || '').trim();
    const list = (signup.dataset.list || '').trim();
    if (provider !== 'klaviyo' || !key || !list) {
      feedback(form, message.unavailable, true);
      return;
    }

    const button = form.querySelector('button[type="submit"]');
    const fields = form.querySelector('[data-mm-newsletter-fields]');
    const label = button.textContent;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    fields.disabled = true;
    button.textContent = message.pending;

    try {
      // Client subscriptions create an email marketing consent record. Only
      // the public site ID goes into the browser; no private API key is used.
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2026-07-15',
        },
        signal: controller.signal,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: signup.dataset.source || 'Japan newsletter',
              profile: { data: { type: 'profile', attributes: {
                email: email.value,
                properties: {
                  signup_store: 'jp.mutemotion.com',
                  preferred_language: 'ja',
                  newsletter_consent_version: '2026-10-15',
                },
              } } },
            },
            relationships: { list: { data: { type: 'list', id: list } } },
          },
        }),
      });
      if (!response.ok) {
        feedback(form, response.status === 429 ? message.rateLimit : message.failed, true);
        return;
      }
      // An accepted request is not proof that double opt-in is complete.
      fields.hidden = true;
      feedback(form, message.accepted).focus();
    } catch {
      feedback(form, message.failed, true);
    } finally {
      clearTimeout(timeout);
      delete form.dataset.submitting;
      form.removeAttribute('aria-busy');
      button.disabled = false;
      fields.disabled = false;
      button.textContent = label;
    }
  });

  // A Klaviyo form is disabled in its HTML until this handler is ready. A
  // blocked script or missing configuration cannot post it to Shopify.
  const initialize = (root = document) => {
    root.querySelectorAll('[data-mm-newsletter][data-provider="klaviyo"]').forEach((signup) => {
      const form = signup.querySelector('form');
      const fields = signup.querySelector('[data-mm-newsletter-fields]');
      if (!form || !fields) return;
      if (!(signup.dataset.key || '').trim() || !(signup.dataset.list || '').trim()) {
        feedback(form, message.unavailable, true);
        return;
      }
      fields.disabled = false;
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
